
import { css } from 'lit';
export default css`
:host{
  display:block;
}

.grid-list{
  display:grid;
  gap:1.5rem;
  grid-template-columns:repeat(5, 240px);
  overflow-x:scroll;
  padding-bottom:1rem;
}

@media (min-width: 992px){

.grid-list{
    display:flex;
    gap:2rem;
    overflow:visible;
    padding-bottom:0
}
  }

:host([pin-featured]) .grid-list{
    display:grid;
    gap:1.5rem;
    grid-template-columns:repeat(5, 240px);
    overflow-x:scroll;
    padding-bottom:1rem;
  }

@media (min-width: 992px){

:host([pin-featured]) .grid-list{
      grid-template-columns:calc(50% - 1.5rem) repeat(2, calc(25% - 1.5rem));
      grid-template-rows:repeat(2, auto);
      gap:2rem;
      overflow:visible;
      padding-bottom:0
  }
    }
`;